import { Request, Response, NextFunction } from 'express';
import * as meetingService from './meeting.service';

export async function createMeetingHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const hostId = (req as any).user.sub;
    const meeting = await meetingService.createMeeting({
      ...req.body,
      hostId,
    });
    res.status(201).json({ success: true, data: meeting });
  } catch (err) {
    next(err);
  }
}

export async function listMeetingsHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const userId = (req as any).user.sub;
    const { startDate, endDate, filter, search } = req.query;
    const meetings = await meetingService.listUserMeetings(userId, {
      startDate: startDate as string,
      endDate: endDate as string,
      filter: filter as any,
      search: search as string,
    });
    res.json({ success: true, data: meetings });
  } catch (err) {
    next(err);
  }
}

export async function getMeetingHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const { idOrCode } = req.params;
    const meeting = await meetingService.getMeetingByCodeOrId(idOrCode);
    res.json({ success: true, data: meeting });
  } catch (err) {
    next(err);
  }
}

export async function updateMeetingHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const userId = (req as any).user.sub;
    const { id } = req.params;
    const meeting = await meetingService.updateMeeting(id, userId, req.body);
    res.json({ success: true, data: meeting });
  } catch (err) {
    next(err);
  }
}

export async function joinMeetingHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const userId = (req as any).user?.sub;
    const { id } = req.params;
    const { guestName, role, status } = req.body;
    const participant = await meetingService.registerParticipantJoin(id, {
      userId,
      guestName,
      role,
      status,
    });
    res.json({ success: true, data: participant });
  } catch (err) {
    next(err);
  }
}

export async function leaveMeetingHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const userId = (req as any).user?.sub;
    const { id } = req.params;
    const { participantId } = req.body;
    const targetId = participantId || userId;
    if (targetId) {
      await meetingService.registerParticipantLeave(id, targetId);
    }
    res.json({ success: true, message: 'Left meeting' });
  } catch (err) {
    next(err);
  }
}

export async function appendTranscriptHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const { id } = req.params;
    const { segment } = req.body;
    if (segment) {
      await meetingService.appendTranscript(id, segment);
    }
    res.json({ success: true, message: 'Transcript recorded' });
  } catch (err) {
    next(err);
  }
}

export async function getMeetingReportHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const { id } = req.params;
    const report = await meetingService.getMeetingReport(id);
    res.json({ success: true, data: report });
  } catch (err) {
    next(err);
  }
}

export async function deleteMeetingHandler(req: Request, res: Response, next: NextFunction) {
  try {
    const userId = (req as any).user.sub;
    const { id } = req.params;
    await meetingService.deleteMeeting(id, userId);
    res.json({ success: true, message: 'Meeting deleted successfully' });
  } catch (err) {
    next(err);
  }
}
